import { useCallback, useState } from "react";
import useCart from "../../hooks/useCart";

const useProduct = (slug) => {
  const { state, dispatch } = useCart();
  const [openModal, setOpenModal] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const cartItem = state.cart.find((item) => item.product.slugName === slug);
  const toggleFavorite = useCallback(() => setIsFavorite((fav) => !fav), []);
  const toggleDialog = useCallback(() => setOpenModal((open) => !open), []);

  const handleCartAmountChange = ({ product, quantity }) => {
    dispatch({
      type: "CHANGE_CART_AMOUNT",
      payload: { product, quantity },
    }); // SHOW ALERT PRODUCT ADDED OR REMOVE
  };

  return {
    cartItem,
    openModal,
    isFavorite,
    toggleDialog,
    toggleFavorite,
    handleCartAmountChange,
  };
};

export default useProduct;
